import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Stack": Stack, "@mui/material/Slider": Slider, "@mui/icons-material/VolumeDown": VolumeDown, "@mui/icons-material/VolumeUp": VolumeUp } } });
export default ClientProvider;
